export const environment = {
  name: 'dev',
  production: false,
  apiBaseUrl: 'https://dev.pmapi.wealthmax.co.uk/api',
  notificationHubBaseUrl: 'https://dev.pmapi.wealthmax.co.uk',
  solutionBuilderBaseUrl: 'https://dev.pmapi.wealthmax.co.uk',
  swaggerUrl: 'https://dev.pmapi.wealthmax.co.uk/swagger'
};